export const gamesData = [
    {
        "order": 1,
        "image": "/tiles/oceanFlow.jpg",
        "link": "oceanFlow",
        "name": "Ocean Flow",
        "cornerImage": "/tiles/corner/jellyfish.png",
        "hasMobile": false
    },
    {
        "order": 2,
        "image": "/tiles/synapseHash.jpg",
        "link": "synapseHash",
        "name": "Synapse Hash",
        "cornerImage": "/tiles/corner/neuron.png",
        "hasMobile": true
    },
    {
        "order": 3,
        "image": "/tiles/bounceFall.jpg",
        "link": "bounceFall",
        "name": "Bounce Fall",
        "cornerImage": "/tiles/corner/ball.png",
        "hasMobile": false
    },
    {
        "order": 4,
        "image": "/tiles/roshambo.png",
        "link": "roshambo",
        "name": "Roshambo",
        "cornerImage": "/tiles/corner/fist.png",
        "hasMobile": false
    },
    // {
    //     "order": 5,
    //     "image": "/tiles/blackhole.webp",
    //     "link": "/voidVoyage",
    //     "name": "Void Voyage",
    //     "cornerImage": "/tiles/corner/blackHole.png"
    // },
]